import { HeadTitle, MenuItem, Spacer } from 'oui';
import { SideBox, DefaultBox, VisualBox } from '../../etc/LBox/LBox';
import { Bottomsheet, Button, Tmd14, Tsmbd22, Trg11 } from 'oui';
import {useMtgCallTime} from "../../../application/bloc/useMtgCallTime";


export const MtgCallTime = () => {
  const {
    callList,
    selected,
    clickItem,
    isOpen,
    callInfo,
    clickCallTimeConfirm,
    CALL_TIME,
    close,
  } = useMtgCallTime()

  return (
    <>
      <HeadTitle
        textTitle={
          '빠르고 정확한 안내를 위해\n 통화하기 편한 시간대를 선택해주세요'
        }
      />
      <Spacer size={'sm'} />
      <SideBox>
        {callList.map((item: any) => {
          return (
            <MenuItem
              key={item.text}
              text={item.text}
              value={item.value}
              isSelected={selected.value === item.value}
              subText={item.text !== item.desc && item.desc}
              state={selected.value === item.value ? 'focused' : 'enabled'}
              onSelectMenuItem={() => {}}
              onClickMenuItem={() => clickItem(item)}
            />
          );
        })}
      </SideBox>

      <Bottomsheet
        backdrop={true}
        isOpen={isOpen}
        isMaxHeight={false}
        children={
          <>
            <HeadTitle textTitle={'전화 안내 신청을 완료해주세요'} buttonIconName={'CloseSharp'} onClickButton={close}/>
            <VisualBox>
              <img src={CALL_TIME} alt={'call-time'} />
            </VisualBox>
            <DefaultBox>
              <div style={{ textAlign: 'center', height: 118 }}>
                <Tmd14 text={`대출에 관한 정보는 ${callInfo.compNm}에서 정확하게 알려드려요`} color={'#696969'} />
                <Tmd14 text={`아래 번호로 전화가 올거에요`} color={'#696969'}/>
                <Spacer size={'sm'} />
                <Tsmbd22 text={callInfo.callNo || '1234-5678'} color={'#FF3A4A'} />
              </div>
            </DefaultBox>
            <SideBox>
              <Spacer size={'xs'}/>
              <Trg11 text={`${callInfo.compNm}에서 최대한 빨리 전화드릴 예정이에요.`} color={'#9C9C9C'} />
              <Trg11 text={`신청이 많거나 휴일일 경우 1~3일 정도 늦어질 수도 있는 점 참고해주세요`} color={'#9C9C9C'} />
              <Spacer size={'xs'}/>
            </SideBox>
            <DefaultBox>
              <Button
                flexible={true}
                configuration={'contained'}
                children={'확인'}
                onClick={(e) => clickCallTimeConfirm(e)}
              />
            </DefaultBox>
          </>
        }
      />
    </>
  );
};
